import { defineComponent as _defineComponent } from 'vue'
import { ASSIGNED_TO_POOL, PENDING_APPROVAL } from '@/models/job'
import { getJobStatusColor, getJobStatusName } from '@/utils/status-formatting'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobStatusChip',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  // props.status should be of type:
  // | ACTIVE
  // | APPROVED
  // | ASSIGNED_TO_POOL
  // | ASSIGNED_TO_SERVICE_PROVIDER
  // | CANCELLED
  // | COMPLETED
  // | DRAFT
  // | NO_APPROVAL
  // | PAUSED
  // | PENDING_APPROVAL
  // | REJECTED
  // | REQUESTED
  // | SCHEDULED
  // | 'UpForGrabs'

  // The reason we can't declare this type here is because of Vue <= 3.2 limitation:
  // "In Vue 3.2 and below, the generic type parameter for defineProps() were limited to a type literal or a reference to a local interface."
  // https://vuejs.org/guide/typescript/composition-api#syntax-limitations
  // Once we upgrade to Vue 3.3, we can properly declare the type of props.status
  status: string
}



const color = computed(() => getJobStatusColor(props.status))
const label = computed(() => getJobStatusName(props.status))
const isOutlined = computed(
  () => props.status === PENDING_APPROVAL || props.status === ASSIGNED_TO_POOL
)

return { __sfc: true,props, color, label, isOutlined }
}

})